import * as React from 'react';

export const LazyFailedStep = React.lazy(() => import('./component'));
